import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "children"];
import React from "react";
import classNames from 'classnames';
import { Box } from '@alifd/next';
import { When } from '@alife/workstation-utils';
import "./index.scss";
export function Item(_ref) {
  var label = _ref.label,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "row",
    align: "flex-start",
    justify: "center"
  }, rest), /*#__PURE__*/React.createElement(When, {
    condition: label
  }, /*#__PURE__*/React.createElement("span", {
    className: "list-description-label"
  }, typeof label === 'string' ? "".concat(label, ":") : label)), /*#__PURE__*/React.createElement(When, {
    condition: children
  }, /*#__PURE__*/React.createElement("span", {
    className: "list-description-value"
  }, children)));
}
export function Description(_ref2) {
  var style = _ref2.style,
    className = _ref2.className,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(Box, {
    spacing: 8,
    className: classNames('list-description', className),
    style: style
  }, children);
}
Description.Item = Item;